var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2601_5118)",
    filter: "url(#filter0_d_2601_5118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.268 3.60385C165.994 3.22256 165.692 2.87183 165.368 2.5431C165.354 2.52721 165.341 2.5101 165.326 2.49543C165.312 2.48199 165.296 2.46977 165.283 2.45633C163.471 0.66234 160.949 -0.312866 158.031 -0.312866C156.375 -0.312866 154.597 -1.80006e-05 152.748 0.617124L16.6262 45.9899C9.42454 48.3912 8.11204 52.5829 7.97151 54.867C7.82975 57.1522 8.61553 61.4734 15.464 64.7437L49.6451 81.068L34.3485 118.841C34.3106 118.932 34.2764 119.025 34.2459 119.118C32.546 124.218 33.2303 128.803 36.1254 131.697C37.9744 133.546 40.5126 134.493 43.4346 134.493C45.0868 134.493 46.8612 134.19 48.7029 133.576C48.797 133.545 48.8886 133.512 48.9803 133.474L86.7543 118.177L103.077 152.357C106.197 158.889 110.31 159.865 112.484 159.865C114.425 159.865 119.223 159.02 121.831 151.195L167.205 15.0729C168.7 10.5892 168.367 6.51602 166.268 3.60385ZM18.1207 55.4963C18.4923 55.3081 18.9786 55.1004 19.5946 54.8951L149.638 11.546L76.2714 84.9138C73.5951 82.6628 70.7966 80.7686 68.1422 79.5013L19.5078 56.2736C18.9224 55.9937 18.4666 55.7285 18.1207 55.4963ZM45.6062 124.715C43.9869 125.235 43.0692 125.145 42.7759 125.046C42.6769 124.752 42.5877 123.835 43.1071 122.216L58.1299 85.1204L64.0972 87.9714C69.7774 90.6832 77.1378 98.0449 79.8508 103.724L82.7019 109.692L45.6062 124.715ZM112.927 148.228C112.722 148.845 112.514 149.33 112.326 149.702C112.093 149.356 111.826 148.9 111.546 148.312L88.3197 99.6788C87.0524 97.0245 85.1582 94.2272 82.9072 91.5496L156.276 18.1818L112.927 148.228Z",
    fill: "#BA00A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2601_5118",
    x: -0.169028,
    y: 0,
    width: 175.805,
    height: 175.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.81356
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.90678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2601_5118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2601_5118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2601_5118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.178,
    height: 160.178,
    fill: "white",
    transform: "translate(7.64453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.6e3533ec2bb2d21bf365dc6177c4fd9f.svg";
export { ForwardRef as ReactComponent };